import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-custom-page-1',
    templateUrl: './custom-page-1.component.html',
    styleUrls: ['./custom-page-1.component.scss'],
})
export class CustomPage1Component implements OnInit {

    constructor(
    ) {

    }
        ngOnInit(): void {
            
        }
}